module.exports = __webpack_public_path__ + "img/07fb576.png";